export const STAGE_AUTO_NAVIGATION = "STAGE_AUTO_NAVIGATION";
export const NAVIGATE_PAGE = "NAVIGATE_PAGE";


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/auto-nav-url/src/actions/actionTypes.js